import { useRef } from "react";
import { Box, Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useIsOverflowing } from "@common/hooks/useIsOverflowing";

interface IOverflowTooltipProps {
    text: string;
    sx?: SystemStyleObject<Theme>;
}

const ellipsisStyles: SystemStyleObject<Theme> = {
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};

function OverflowTooltip({ text, sx }: IOverflowTooltipProps) {
    const textRef = useRef<HTMLDivElement>(null);
    const isOverflowing = useIsOverflowing(textRef, text);

    return (
        <DotLegalTooltip text={text} position="right" tooltipStyle="primary" useBoldText disableHoverlistener={!isOverflowing}>
            <Box ref={textRef} sx={{ ...ellipsisStyles, ...sx }}>
                {text}
            </Box>
        </DotLegalTooltip>
    );
}

export default OverflowTooltip;
